import React from "react";

const Button = ({ onClick, title, className = "bg-red text-white", style }) => (
    <p className={`px-md py-sm rounded-lg pointer ${className}`} onClick={onClick} style={style}>
        {title}
    </p>
);

export default Button;
